import styles from "./GoogleLoginButton.module.scss";
import React from "react";

export const GoogleLoginButton = ({onClick, label}) => {
  return <div onClick={onClick} className={styles.btnGoogle}>
    <div className={styles.icon}></div>

    {label}
  </div>
}
